
const FILTER_PRINT_LABELS = {
    name: "Nome",
    nickname: "Apelido",
    cpf: "CPF",
    rg: "RG",
    cnh: "CNH",
    socialName: "Nome social",
    sex: "Sexo",
    maritalStatus: "Estado civil",
    nationality: "Nacionalidade",
    cityOfBirth: "Naturalidade",
    mother: "Nome da mãe",
    father: "Nome do pai",
    height_max: "Altura máx. (cm)",
    height_min: "Altura mín. (cm)",
    color: "Cútis",
    bodyShape: "Compleição",
    eyes: "Cor dos olhos",
    hairType: "Tipo dos cabelos",
    hairColor: "Cor dos cabelos",
    local: "Local",
    type: "Tipo",
    description: "Descrição",
    isHomeless: "Situação de rua",
    address: "Logradouro",
    neighborhood: "Bairro",
    city: "Município",
    complement: "Complemento",
    zipCode: "CEP",
    roleCrime: "Função no crime",
    situation: "Situação",
    socialNetwork: "Rede social",
    educationDegree: "Grau de instrução",
    occupation: "Profissão",
    information: "Informações do indivíduo",
    article: "Artigos indiciados",
    individualReferral: "Encaminhamento",
    dtBirth_max: "Idade mínima",
    dtBirth_min: "Idade máxima",
    indHasOccurrence: "Relacionado a ocorrências",
    phone: "Telefone",
    hasSos: "Relacionado a SOS",
    hasEncounter: "Relacionado a abordagens",
    hasBos: "Relacionado a BO",
    alcoholDrugDependency: "Dependência álcool/drogas",
    mentalDisorder: "Transtorno mental",
}

export default FILTER_PRINT_LABELS;